import COLORS from '../../utils/constants/colors'

const gameScoreStyles = () => ({
  gameContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr auto auto auto auto 1fr',
    alignItems: 'center',
    columnGap: '10px',
    padding: '5px 0',
    margin: '10px 0',
    borderRadius: '8px',
    flex: 1,
    minWidth: 0,
  },
  teamNameLeft: {
    textAlign: 'right',
    margin: '0 10px',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  teamNameRight: {
    textAlign: 'left',
    margin: '0 10px',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  teamLogo: {
    width: '40px',
    height: '40px',
  },
  score: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2px 10px',
    borderRadius: '8px',
    fontWeight: 'bold',
    border: '2px solid #E0726E',
    minWidth: '45px',
  },
  highScore: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E0726E',
    border: '2px solid #E0726E',
    padding: '2px 10px',
    borderRadius: '8px',
    fontWeight: 'bold',
    color: COLORS.white,
    minWidth: '45px',
  },
  scoreNumber: {
    margin: '0 5px',
  },
})

export default gameScoreStyles
